import classNames from 'classnames';
import React from 'react';
import Divider from '@wg/wows-react-uikit/components/Divider/Divider';
import Interpolate from '@wg/wows-react-uikit/components/Interpolate/Interpolate';

import { isoToFormattedLocalDateTime } from '~/helpers/datetime';
import { t } from '~/helpers/localization';

import Countdown from '~/Components/UIKit/Countdown/Countdown';

import styles from './EventCountdown.scss';
import Icon from './images/icon_countdown.svg';

type ICountdown = {
  date: number;
  className?: string;
  additionalText?: string;
  showEndDate?: boolean;
};

const EventCountdown: React.FC<ICountdown> = ({ date, className, additionalText = null, showEndDate = false }) => {
  return (
    <div className={classNames(styles.wrapper, className)}>
      <Divider type={'major_light'} />
      <div className={styles.message}>
        <img className={styles.icon} src={Icon} width={13} height={13} />
        {additionalText ? `${additionalText} ` : null}
        {showEndDate ? (
          t('Available until: %(datetime)s', { datetime: isoToFormattedLocalDateTime(date) })
        ) : (
          <Interpolate str={t('Ends in %(timeleft)s')} timeleft={<Countdown date={date} />} />
        )}
      </div>
      <Divider type={'major_light'} />
    </div>
  );
};

export default EventCountdown;
